export default "__VITE_ASSET__C9zs1Es4__"